import React, { useState, useCallback, useEffect, useContext, useMemo, useRef } from "react";
import { graphql, useStaticQuery, withPrefix } from "gatsby";
import { Link } from "./link";
import CompareContext from "../context/compare";
import Confronta from "../icons/confronta.svg";
import placeholderImg from "../images/placeholder.png";
import babelConfig from "../../babel-config.json";

const CompareBar = ({ to, products, config }) => {
  const { productIds, removeProduct, clearProducts, loaded } = useContext(CompareContext);
  const onRemoveProduct = useCallback((e) => removeProduct(e.currentTarget.name), [removeProduct]);
  const prodotti = useMemo(() => {
    const list = productIds
      .map((pId) => products.find((item) => item.key_prod === pId))
      .filter(Boolean)
      .map((item) => ({
        ...item,
        image: item.primaryimage.find((item) => item.imageType === "640"),
      }));
    return list.concat(new Array(3 - productIds.length).fill(0));
  }, [products, productIds]);
  const [expanded, setExpanded] = useState(false);
  const toggleExpand = useCallback(() => setExpanded((value) => !value), []);
  const isEmpty = !productIds.length;
  useEffect(() => {
    if (isEmpty) {
      setExpanded(false);
    }
  }, [isEmpty]);

  // Al primo inserimento, apro la barra
  const productsRef = useRef(null);
  useEffect(() => {
    if (loaded) {
      if (productsRef.current === 0 && productIds.length === 1) {
        setExpanded(true);
      }
      productsRef.current = productIds.length;
    }
  }, [loaded, productIds.length]);

  const { labelManagerLabels } = useStaticQuery(graphql`
    {
      labelManagerLabels: labelManagerLabels {
        compare
        compareProducts
        deselectAll
        expand
        product
        products
      }
    }
  `);

  const pathPrefix = withPrefix("/");
  return (
    <div className={`compare-bar px-md-3${isEmpty ? " d-none" : ""}${expanded ? " expanded" : ""}`}>
      <div className={`container-fluid${expanded ? " d-none" : ""}`}>
        <div className="row">
          <div className="col-12">
            <button
              className="compare-bar__btn d-flex justify-content-between align-items-center"
              aria-label={labelManagerLabels.expand}
              onClick={toggleExpand}
              aria-expanded={expanded}
            >
              <Link to={to} className="compare-bar__link d-inline-flex align-items-center">
                <Confronta className="compare-bar__icon mr-3" />
                <span className="compare-bar__title">
                  {labelManagerLabels.compare} {productIds.length}{" "}
                  {(productIds.length === 1
                    ? labelManagerLabels.product
                    : labelManagerLabels.products
                  ).toLowerCase()}
                </span>
              </Link>
              <span className="compare-bar__toggle"></span>
            </button>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-3 mb-md-4 mb-lg-0 order-lg-2">
            <div className="text-center">
              <div className="text-right">
                <button
                  className="compare-bar__toggle"
                  onClick={toggleExpand}
                  aria-expanded={expanded}
                  aria-label={labelManagerLabels.expand}
                ></button>
              </div>
              <Link to={to} className="btn-link btn-link--white mt-5 px-3">
                {labelManagerLabels.compareProducts}
              </Link>
              <button
                className="compare-bar__clear-btn d-flex justify-content-center align-items-center mt-5 mx-auto"
                onClick={clearProducts}
              >
                <span className="icon-close mr-2"></span>
                {labelManagerLabels.deselectAll}
              </button>
            </div>
          </div>
          <div className="col-lg-9">
            <div className="row">
              {prodotti.map((item, i) => (
                <div className="col-md-4 mt-5 mt-md-0" key={item ? item.key_prod : i}>
                  <div className="compare-bar__product">
                    {item ? (
                      <>
                        <div className="compare-bar__img-wrapper">
                          <div className="compare-bar__square">
                            <button
                              className="compare-bar__remove"
                              name={item.key_prod}
                              onClick={onRemoveProduct}
                              aria-label="Remove"
                            >
                              <span className="icon-close"></span>
                            </button>
                            <img
                              src={item?.image?.imageUrl || placeholderImg}
                              className="compare-bar__img"
                              alt={item.productName}
                            />
                          </div>
                        </div>
                        <div className="compare-bar__label mt-4">
                          {item?.lineId === 333 &&
                          !(item?.familiesIds?.length > 0) &&
                          item?.productTitleNoFamilyAC
                            ? item?.productTitleNoFamilyAC
                            : item?.familiesIds &&
                              item?.familiesIds?.length &&
                              (config?.invertProductFamily === "yes" ||
                                babelConfig.invertProductFamilyPaths.includes(pathPrefix))
                            ? `${item?.familiesIds?.[0]?.title} ${item?.pageLine?.pageName?.[0]}`
                            : item?.familiesIds && item?.familiesIds?.length
                            ? `${item?.pageLine?.pageName?.[0]} ${item?.familiesIds?.[0]?.title}`
                            : item?.pageLine?.pageName?.[0]}
                        </div>
                        <div className="compare-bar__label mt-2">{item.productCode}</div>
                      </>
                    ) : (
                      <div className="compare-bar__img-wrapper compare-bar__img-wrapper--empty">
                        <div className="compare-bar__square"></div>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompareBar;
